import type { IPresenceIndicatorComponent } from '@getgo/chameleon-web'
import type { PopoverPosition } from '@getgo/chameleon-core'

export const GOTO_PRESENCE_INDICATOR = 'goto-presence-indicator'

// we want presence to be private
export interface PresenceProps extends Readonly<Omit<IPresenceIndicatorComponent, 'presence'>> {
  readonly externalUserKey: string
  readonly presenceSnapshot?: boolean
  readonly tooltipPosition?: PopoverPosition
}
